import { useField } from 'formik'
import React, { FC } from 'react'

import TypeUtil from '@/utils/typeUtil'

import { Input, InputProps } from './Input'

type InputFieldProps = Omit<InputProps, 'name' | 'onChange' | 'value'> & {
  name: string
  onChange?: (value: string | null) => void
  formatValue?: (text: string) => string
}

const InputField: FC<InputFieldProps> = ({ formatValue, onChange, ...props }) => {
  const [field, , helper] = useField(props)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (TypeUtil.isEmpty(e.target.value)) {
      helper.setValue(null)
      onChange?.(null)
    } else {
      const value = formatValue ? formatValue(e.target.value) : e.target.value
      helper.setValue(value)
      onChange?.(value)
    }
  }

  return (
    <Input
      {...field}
      {...props}
      onChange={handleChange}
    />
  )
}

export type { InputFieldProps }

export { InputField }
